import amplitude from 'amplitude-js';
import decode from 'jwt-decode';
import { REACT_APP_ENV } from 'config';
import { ENVIRONMENT } from 'utils/constants';

// Lazily initialized here so events fire from ANY entry route (fresh /login,
// the emailed /auth/verify, the /assistant webview) — historically the SDK
// was only initialized inside EvieOnboarding, and logEvent silently dropped
// everything on routes loaded before it.
let initialized = false;

const ensureInitialized = () => {
  const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;
  if (initialized || !apiKey) return;

  amplitude.getInstance().init(apiKey, null, { autocapture: true, includeUtm: true });
  amplitude.getInstance().identify(new amplitude.Identify().set('test', REACT_APP_ENV === ENVIRONMENT.DEVELOPMENT));
  initialized = true;
};

export function handleTrackEvent(event, props = null) {
  ensureInitialized();
  amplitude.getInstance().logEvent(event, props);
}

export function setUserProperty(name, value) {
  ensureInitialized();
  amplitude.getInstance().identify(new amplitude.Identify().set(name, value));
}

export function setAnalyticsUser(id) {
  if (!id) return;
  ensureInitialized();
  const instance = amplitude.getInstance();
  const currentId = instance.getUserId();
  if (currentId && currentId !== String(id)) {
    instance.setUserId(null);
    instance.regenerateDeviceId();
  }
  instance.setUserId(id);
}

export function identifyAnalyticsFromToken(token) {
  if (!token) return;
  let payload;
  try {
    payload = decode(token);
  } catch (error) {
    return;
  }
  setAnalyticsUser(payload.user_id);
}

export function resetAnalyticsUser() {
  ensureInitialized();
  amplitude.getInstance().setUserId(null);
  amplitude.getInstance().regenerateDeviceId();
}
